import React, { useState, useEffect } from 'react';
import '../../styles/EditStudentPopupst.css';

const EditStudentPopup = ({ isOpen, onClose, student, onSave }) => {
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        if (student) {
            setStatus(student.studentProgressStatus || '');
        }
    }, [student]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${process.env.REACT_APP_API_URL}/update/${student.id || student._id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ studentProgressStatus: status })
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.message || 'Failed to update status');
            }

            const updatedStudent = await response.json();
            setSuccess('Progress status updated successfully!');
            setTimeout(() => {
                onSave({ ...student, studentProgressStatus: status });
            }, 1000);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen || !student) return null;

    return (
        <div className="payment-modal-overlay">
            <div className="payment-modal">
                <div className="payment-modal-header">
                    <h2>Update Student Progress Status</h2>
                    <button className="modal-close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="payment-modal-content">
                    <div className="payment-field-group">
                        <label>Progress Status:</label>
                        <select
                            name="studentProgressStatus"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className="editable-field"
                            required
                        >
                            <option value="">Select Status</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Course Completed">Course Completed</option>
                            <option value="Course and Certified Completed">Course and Certified Completed</option>
                            <option value="Course Completed, Certified, and Successfully Placed">Course Completed, Certified, and Successfully Placed</option>
                            <option value="Successfully Placed">Successfully Placed</option>
                            <option value="Discontinued">Discontinued</option>
                            <option value="Discontinued & Refunded">Discontinued & Refunded</option>
                            <option value="Terminated">Terminated</option>
                            <option value="Terminated & Refunded">Terminated & Refunded</option>
                            <option value="Inactive">Inactive</option>
                        </select>
                    </div>

                    {error && <div className="error-message">{error}</div>}
                    {success && <div className="success-message">{success}</div>}
                </div>

                <div className="payment-modal-actions">
                    <button
                        className="btn-submit"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button className="btn-cancel" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default EditStudentPopup;
